import { Stack, Skeleton, Box } from '@packages/shared';

export const RecoProductCardSkeleton = () => (
  <Stack direction="column" spacing={2}>
    <Skeleton width="100%" height={200} variant="rectangular" />
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Skeleton variant="rectangular" width="50%" height={15} />
      <Skeleton variant="rectangular" width="100%" height={15} />
      <Skeleton variant="rectangular" width="50%" height={15} sx={{ mt: 1 }} />
      <Skeleton variant="rectangular" width="50%" height={15} />
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <Skeleton variant="rectangular" height={30} width={40} />
        <Skeleton variant="rectangular" height={30} width={40} />
        <Skeleton variant="rectangular" height={30} width={40} />
      </Stack>
    </Box>
  </Stack>
);
